import { Button, Icon, Layout, Link, Text } from '@loadsmart/miranda-react'

import { user } from 'legacy/utils/user'

import { TrackingProvider, TT_PROVIDER_LINK } from '../../domain/Tracking'
import { ProvidersBadge } from './ProvidersBadge'
import { ProviderCard } from './styles'

type EmptyTruckNumberCardContentProps = {
  readonly onClick: () => void
}

export function EmptyTruckNumberCardContent({ onClick }: EmptyTruckNumberCardContentProps) {
  return (
    <ProviderCard onClick={onClick} aria-labelledby="assign-truck-label">
      <Layout.Stack gap="spacing-2">
        <Layout.Group align="center" justify="space-between">
          <Layout.Group gap="spacing-2">
            <ProvidersBadge providers={[TrackingProvider.TT]} />
          </Layout.Group>
          <Button aria-label="Add truck number" variant="icon-secondary" size="small">
            <Icon name="add-circle" size="20px" color="color-text-placeholder" />
          </Button>
        </Layout.Group>

        <Text id="assign-truck-label" variant="body-md-bold" color="color-text-secondary">
          Add the truck number to track with ELD
        </Text>
        <Text variant="body-sm" color="color-text-placeholder">
          Use truck number to connect and provide tracking using ELD providers.
        </Text>
        {!user.isLoggedIn() && (
          <Text variant="body-sm" color="color-text-placeholder">
            Setup it on{' '}
            <Link href={TT_PROVIDER_LINK} target="_blank" rel="noopener noreferrer">
              Trucker Tools
            </Link>
          </Text>
        )}
      </Layout.Stack>
    </ProviderCard>
  )
}
